<app-header></app-header>

<div class="bg-grey pt-5">
    <div class="container pt-5">
        <div class="row mb-3">
            <div class="col text-center">
                <h5 class="h5">Listed by Forbes as one of the fastest growing organizations and recognized by Microsoft, OMNI Platform brings to you World’s first hands-on training for AI & RPA skills.</h5>
            </div>
        </div>
        <div class="row">
          <div class="col-md-7">
            <h1 class="h2 text-left mb-4">Grow one citizen developer at a time with:</h1>
            <ul class="custom-bullet">
            	<li>Guided training by tech professionals</li>
                <li>Build your internal team of automation experts</li>
                <li>Freedom from expensive consultants in just 90 days</li>
                <li>Choice of selecting the best fit AI & RPA tool</li>
            </ul>
          </div>
      
        <div class="col-md-5 form-bg bg-white p-5 mt-2 mb-5">
            <form>
                <div class="row">                                
                    <div class="col-md-12 mb-4">
                        <input [(ngModel)]="name"  name ="name"class="search form-control pl-3" type="text" placeholder="Name*" required #nameref="ngModel">
                        <div *ngIf="nameref.invalid && ( nameref.touched) || showValidations" class="alert">

                            <div *ngIf="nameref.errors?.required">
                                <span class="error"> Name is required.</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 mb-4">
                        <input [(ngModel)]="email" name="email"  class="search form-control pl-3" type="text" placeholder="Email*" required #emailref="ngModel">
                        <div *ngIf="emailref.invalid && ( emailref.touched) || showValidations" class="alert">

                            <div *ngIf="emailref.errors?.required">
                                <span> Email is required.</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 mb-4">
                        <input [(ngModel)]="title" name="demo-title"  class="search form-control pl-3" type="text" placeholder="Title">
                    </div>
                </div>                           
                 <p class="small mt-2">By activating this benefit, you agree to abide by Omni's <a  target="_blank" href="https://app.omnicoe.com/tnc" class="active">terms of use</a> and <a  target="_blank" href="https://app.omnicoe.com/tnc" class="active">privacy policy</a>.</p>
                <div class="pt-4">
                    <a (click)="schedule()" target="_blank" class="bg-button btn btn-primary bd-highlight text-white">Submit</a>
                </div>
            </form>
        </div>
        
      </div>
    </div>
</div>

<app-footer></app-footer>
    